let duplicateDialogTrigger;
let restoreDuplicateDialogFocus = true;

function duplicateDialog() {
  return document.querySelector("[data-host-offer-duplicate-dialog]");
}

function openDuplicateDialog(trigger) {
  const dialog = duplicateDialog();
  const form = dialog?.querySelector("[data-host-offer-duplicate-form]");
  const heading = dialog?.querySelector("[data-host-offer-duplicate-heading]");
  const duplicateUrl = trigger.dataset.hostOfferDuplicateUrl;
  const sourceHotel = trigger.dataset.hostOfferDuplicateHotel;
  const title = trigger.dataset.hostOfferDuplicateTitle;
  const titleTemplate = dialog?.dataset.hostOfferDuplicateTitleTemplate;
  if (!dialog || !form || !heading || !duplicateUrl || !title || !titleTemplate) return;

  form.setAttribute("action", duplicateUrl);
  heading.textContent = titleTemplate.replace("__OFFER_TITLE__", () => title);

  let firstTarget;
  form.querySelectorAll("[data-host-offer-duplicate-option]").forEach(function (option) {
    const isSource = option.value === sourceHotel;
    option.checked = false;
    option.disabled = isSource;
    const label = option.closest("label");
    if (label) label.hidden = isSource;
    if (!isSource && !firstTarget) firstTarget = option;
  });
  if (firstTarget) firstTarget.checked = true;

  duplicateDialogTrigger = trigger;
  restoreDuplicateDialogFocus = true;

  if (!dialog.open && typeof dialog.showModal === "function") {
    dialog.showModal();
  } else if (!dialog.open) {
    dialog.setAttribute("open", "");
  }
  dialog.querySelector("[data-host-offer-duplicate-cancel]")?.focus();
}

function closeDuplicateDialog({ restoreFocus = true } = {}) {
  const dialog = duplicateDialog();
  if (!dialog?.open) return;

  restoreDuplicateDialogFocus = restoreFocus;
  if (typeof dialog.close === "function") {
    dialog.close();
  } else {
    dialog.removeAttribute("open");
    if (restoreFocus) duplicateDialogTrigger?.focus();
  }
}

document.addEventListener("click", function (event) {
  const duplicateOpen = event.target.closest?.("[data-host-offer-duplicate]");
  if (duplicateOpen) {
    event.preventDefault();
    openDuplicateDialog(duplicateOpen);
    return;
  }

  if (event.target.closest?.("[data-host-offer-duplicate-close]")) {
    closeDuplicateDialog();
    return;
  }

  const dialog = event.target.closest?.("[data-host-offer-duplicate-dialog]");
  if (dialog && event.target === dialog) closeDuplicateDialog();
});

document.addEventListener("close", function (event) {
  if (!event.target.matches?.("[data-host-offer-duplicate-dialog]")) return;

  if (restoreDuplicateDialogFocus) duplicateDialogTrigger?.focus();
  restoreDuplicateDialogFocus = true;
}, true);

document.addEventListener("turbo:before-render", function () {
  closeDuplicateDialog({ restoreFocus: false });
});
